import { useCallback, useState } from 'react';

export const useToggler = (initialValue?: boolean) => {
  const [value, setValue] = useState<boolean>(Boolean(initialValue));

  const setTrue = useCallback(() => {
    setValue(true);
  }, [setValue]);

  const setFalse = useCallback(() => {
    setValue(false);
  }, [setValue]);

  const toggle = useCallback(() => {
    setValue((prev) => !prev);
  }, [setValue]);

  return {
    value,
    toggle,
    setValue,
    setTrue,
    setFalse,
  };
};
